import { createContext, useContext, useState, ReactNode } from "react";

export interface SelectedReference {
  id: string;
  title: string;
  category: string;
}

interface EnquiryContextValue {
  reference: SelectedReference | null;
  setReference: (r: SelectedReference) => void;
  clearReference: () => void;
}

const EnquiryContext = createContext<EnquiryContextValue>({
  reference: null,
  setReference: () => {},
  clearReference: () => {},
});

export function EnquiryProvider({ children }: { children: ReactNode }) {
  const [reference, setRef] = useState<SelectedReference | null>(null);
  return (
    <EnquiryContext.Provider
      value={{
        reference,
        setReference: setRef,
        clearReference: () => setRef(null),
      }}
    >
      {children}
    </EnquiryContext.Provider>
  );
}

export const useEnquiry = () => useContext(EnquiryContext);
